import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "page-title-container d-flex px-4 px-md-0" }
const _hoisted_2 = { class: "text-center m-auto" }
const _hoisted_3 = {
  key: 0,
  class: "font-weight-bold mb-4 text-verydarkblue"
}
const _hoisted_4 = {
  key: 1,
  class: "font-weight-bold mb-4 text-verydarkblue"
}

import { ref } from 'vue';
import defaultSliderBg from '@/assets/default-slider-bg.jpg';

interface Props {
  pageTitle: string | null;
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitle',
  props: {
    pageTitle: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;


const pageTitle = ref(props.pageTitle);

// eslint-disable-next-line no-undef
__expose({
  pageTitle,
});

return (_ctx: any,_cache: any) => {
  return (pageTitle.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "page-title",
        class: "w-100",
        style: _normalizeStyle(`background-image: url(${_unref(defaultSliderBg)})`),
        dir: "rtl"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (pageTitle.value.length < 50)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(pageTitle.value), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(pageTitle.value), 1))
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}
}

})